import { makeModuleStateSelector } from "@client/content/selectors";
import { defaultState, previewState } from "./reducer";
import { type MemberRecurringOrders } from "./types";

export const localStateSelector = makeModuleStateSelector<MemberRecurringOrders.AppState>(defaultState, previewState);
